export default __webpack_public_path__ + "static/media/AvatarLava.0c221429.png";